import React, { Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { formatTitle } from 'core/helpers/wp-data-helpers'
import withView from 'core/components/withView'
import useFetch from 'core/hooks/use-fetch'

import Window from 'core/components/Window'
import WPArticle from 'core/components/WPArticle'
import RelatedProjects from 'project/components/RelatedProjects'

const Project = props => {
  const { loading, error, data } = useFetch(`/project/${props.match.params.id}`)

  useEffect(() => {
    if (data && data.post_title) {
      document.title = formatTitle(data.post_title)
    }
  }, [data])

  const handleClose = () => {
    props.history.push('/projects/')
  }

  return (
    <div className={props.className}>
      <Window
        open
        loading={loading}
        mobile={global.mobile}
        fullscreen
        titlebar={{
          title: data ? data.post_title : '',
          close: handleClose,
          previous: data && data.previous_post ? `/project/${data.previous_post}` : null,
          next: data && data.next_post ? `/project/${data.next_post}` : null
        }}
      >
        <WPArticle>
          {data && (
            <div className="project">
              <article className="project">
                <section className="project-main wp-block-columns">
                  <div className="project-info wp-block-column">
                    <h1 className="project-title type-heading mod-lg-head">{data.post_title}</h1>

                    {data.post_excerpt.length > 0 && (
                      <p className="project-excerpt">{data.post_excerpt}</p>
                    )}

                    {data.fields.pdf_file && (
                      <a
                        className="project-readmore"
                        href={data.fields.pdf_file.url}
                        target="_blank"
                      >
                        Readmore.pdf
                      </a>
                    )}

                    <table className="project-data">
                      <tbody>
                        <tr className="project-data-row">
                          <td className="project-data-cell mod-def">Client</td>
                          <td className="project-data-cell">
                            {data.fields.client ? data.fields.client : 'Witheld'}
                          </td>
                        </tr>

                        {data.terms.project_type ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Type</td>
                            <td className="project-data-cell">
                              {data.terms.project_type.map((type, i) => (
                                <Fragment key={i}>
                                  {i !== 0 && ', '}
                                  <Link
                                    to={`/projects/?filter=type&value=${type.name.toLowerCase()}`}
                                  >
                                    {type.name}
                                  </Link>
                                </Fragment>
                              ))}
                            </td>
                          </tr>
                        ) : null}

                        {data.terms.project_location ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Location</td>
                            <td className="project-data-cell">
                              {data.terms.project_location.map((location, i) => (
                                <Fragment key={i}>
                                  {i !== 0 && ', '}
                                  <Link
                                    to={`/projects/?filter=location&value=${location.name.toLowerCase()}`}
                                  >
                                    {location.name}
                                  </Link>
                                </Fragment>
                              ))}
                            </td>
                          </tr>
                        ) : null}

                        {data.fields.area ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Area</td>
                            <td className="project-data-cell">{data.fields.area}</td>
                          </tr>
                        ) : null}

                        {data.fields.status ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Status</td>
                            <td className="project-data-cell">{data.fields.status}</td>
                          </tr>
                        ) : null}

                        {data.fields.collaborators ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Collaborators</td>
                            <td className="project-data-cell">{data.fields.collaborators}</td>
                          </tr>
                        ) : null}

                        {data.fields.photo_credit ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Photo Credit</td>
                            <td className="project-data-cell">{data.fields.photo_credit}</td>
                          </tr>
                        ) : null}

                        {data.fields.awards ? (
                          <tr className="project-data-row">
                            <td className="project-data-cell mod-def">Awards</td>
                            <td className="project-data-cell">
                              {data.fields.awards.map((award, i) => (
                                <Fragment key={i}>
                                  {i !== 0 && ', '}
                                  {award.award_link.length > 0 ? (
                                    <a
                                      href={award.award_link}
                                      target={award.award_link_target ? '_blank' : null}
                                    >
                                      {award.award_name}
                                    </a>
                                  ) : (
                                    award.award_name
                                  )}
                                </Fragment>
                              ))}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>

                  <div className="project-featured wp-block-column">
                    {data.featured_image['feature-lg'] && (
                      <img
                        className="project-featured-image"
                        src={data.featured_image['feature-lg'][0]}
                        width={data.featured_image['feature-lg'][1]}
                        height={data.featured_image['feature-lg'][2]}
                        alt=""
                      />
                    )}
                  </div>
                </section>

                <section
                  className="project-secondary"
                  dangerouslySetInnerHTML={{ __html: data.post_content }}
                ></section>

                {data.related && <RelatedProjects items={data.related} />}
              </article>
            </div>
          )}
        </WPArticle>
      </Window>
    </div>
  )
}

export default withView(Project)
